import { render, staticRenderFns } from "./CartDiscountProducts.vue?vue&type=template&id=19a05f5a&scoped=true&"
import script from "./CartDiscountProducts.vue?vue&type=script&lang=js&"
export * from "./CartDiscountProducts.vue?vue&type=script&lang=js&"
import style0 from "./CartDiscountProducts.vue?vue&type=style&index=0&id=19a05f5a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a05f5a",
  null
  
)

export default component.exports